const valueListHtml = require('./valueList.html');

/* @ngInject */
export function valueListDirective(): ng.IDirective {
  return {
    restrict: 'E',
    scope: {
      values: '='
    },
    templateUrl: valueListHtml,
    replace: true
  };
}
